<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xs="12" sm="12" lg="2">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xs="12" sm="12" lg="1">
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="12" lg="2">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xs="12" sm="12" lg="1">
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="12" lg="1">
        <v-btn dark @click="carregaServicesPainel(empresaSelecionada ? empresaSelecionada : companyobj.id)" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando pedidos..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">RELATÓRIO</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" class="mt-4" icon="info">Nenhum relatório encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.aluno.nome`]="{ item }">
            <v-chip dark :color="retornaCorAluno(item)" v-if="item.aluno.nome">{{ item.aluno.nome }}</v-chip>
          </template>
          <template v-slot:[`item.login`]="{ item }">
            <p style="margin: 0px" v-if="item.login">{{ formatDateHour(item.login) }}</p>
          </template>
          <template v-slot:[`item.logout`]="{ item }">
            <p style="margin: 0px" v-if="item.logout">{{ formatDateHour(item.logout) }}</p>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <p style="margin: 0px" v-if="item.logout">{{ calculaTempoTreino(item.login, item.logout) }}</p>
            <p style="margin: 0px; color: #aaa" v-else>Em treino</p>
          </template>
          <template v-slot:[`item.notaAula`]="{ item }">
            <v-row dense v-if="item.logout && item.notaAula >= 1">
              <v-rating
                :color="item.notaAula < 9 ? 'red' : 'warning'"
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                half-icon="mdi-star-half-full"
                half-increments
                length="5"
                size="20"
                :value="(item.notaAula / 2)"
                readonly
              ></v-rating>
              <p style="margin-bottom: 0px; margin-top: 8px; color: #aaa">({{ (item.notaAula) }})</p>
            </v-row>
            <p style="margin: 0px; color: #aaa" v-else-if="item.logout && item.notaAula == 0">Não avaliou</p>
            <p style="margin: 0px; color: #aaa" v-else>Aguardando finalizar para avaliar</p>
          </template>
          <template v-slot:[`item.canal`]="{ item }">
            <p style="margin: 0px" v-if="item.canal">{{ item.canal }}</p>
            <p style="margin: 0px; color: #aaa" v-else>Não avaliou</p>
          </template>
          <template v-slot:[`item.justificativa`]="{ item }">
            <v-tooltip bottom v-if="item.justificativa">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="#01579B">mdi-eye</v-icon>
              </template>
              <span>{{ item.justificativa }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="editarItem(item)" :disabled="Boolean(item.logout) || (formatDate(item.login.substring(0, 10)).substring(0, 2) < diaAtual)">
                  <v-icon color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="efetuarLogout(item)" :disabled="Boolean(item.logout)">
                  <v-icon color="error">mdi-logout-variant</v-icon>
                </v-btn>
              </template>
              <span>Efetuar logout</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" ls="12" sm="12" md="12" lg="12">
        <v-btn dark color="#424f4e" :disabled="tabela.conteudo.length == 0" @click="exportar">
          <v-icon left size="25" color="white">cloud_download</v-icon>
          Baixar Relatório
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoEditaAluno" max-width="600px" persistent scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                hide-details
                readonly
                :value="editedItem.aluno.nome"
                :label="editedItem.aluno.sexo == 'MASCULINO' ? 'Aluno' : 'Aluna'"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                hide-details
                readonly
                :value="editedItem.login ? formatDateHour(editedItem.login) : '-----'"
                label="Entrada"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                hide-details
                readonly
                :value="editedItem.logout ? formatDateHour(editedItem.logout) : '-----'"
                label="Saída"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                hide-details
                readonly
                v-model="editedItem.professor.nome"
                label="Professor de origem"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                outlined
                dense
                hide-details
                :items="professores"
                v-model="professorIdDestino"
                label="Professor de destino"
                item-text="nome"
                item-value="id"
                :loading="loadingSelect"
                :disabled="loadingSelect"
                no-data-text="Nenhum outro professor disponível"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="professorIdDestino">
              <v-textarea
                label="Justificativa"
                auto-grow
                outlined
                v-model="justificativaTransferencia"
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialogoEditaAluno = false" text>Fechar</v-btn>
          <v-btn color="success" @click="salvarItem" text>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import { exportarParaExcel } from '@/utils/excel'
  export default {
    components: {Snackbar, Loading},
    data: vm => ({
      isLoading: false,
      fullPage: true,
      date: new Date().toISOString().substring(0, 10),
      mask:"##:##:##",
      menu: false,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        cabecalho: [
          { text: 'Aluno(a)', value: 'aluno.nome', align: 'start' },
          { text: 'Entrada', value: 'login' },
          { text: 'Saída', value: 'logout' },
          { text: 'Tempo de treino', value: 'created' },
          { text: 'Professor', value: 'professor.nome' },
          { text: 'Avaliação', value: 'notaAula' },
          { text: 'Canal', value: 'canal' },
          { text: 'Justificativa', value: 'justificativa', align: 'center' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      editedItem: {
        login: '',
        logout: '',
        alunoId: '',
        professorId: '',
        empresaId: '',
        aluno: {
          nome: '',
          sexo: '',
          whatsapp: '',
          cpf: '',
          foto: '',
          uuid: '',
          empresaId: '',
        },
        professor: {
          nome: '',
          sexo: '',
          whatsapp: '',
          cpf: '',
          foto: '',
          qtdMaximaAlunos: 4,
          faceId: '',
          empresaId: '',
          created: '',
          dataNascimento: '',
        },
      },
      defaultEditedItem: {
        login: '',
        logout: '',
        alunoId: '',
        professorId: '',
        empresaId: '',
        aluno: {
          nome: '',
          sexo: '',
          whatsapp: '',
          cpf: '',
          foto: '',
          uuid: '',
          empresaId: '',
        },
        professor: {
          nome: '',
          sexo: '',
          whatsapp: '',
          cpf: '',
          foto: '',
          qtdMaximaAlunos: 4,
          faceId: '',
          empresaId: '',
          created: '',
          dataNascimento: '',
        },
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndex: -1,
      dialogoEditaAluno: false,
      professores: [],
      diaAtual: '',
      loadingSelect: false,
      professorIdDestino: '',
      justificativaTransferencia: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar entrada' : 'Transferir aluno'
      },  
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },

      dialogoEditaAluno(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultEditedItem)
            this.professorIdDestino = ''
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        // this.carregaProfessores(this.empresaSelecionada)
        this.carregaServicesPainel(this.empresaSelecionada)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaServicesPainel(this.companyobj.id)
      }

      this.diaAtual = moment().format('DD')
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaProfessores(id) {
        this.professores = []
        await axios.get(baseApiUrl + 'Professores?filter={"where":{"empresaId":"' + id + '"}, "order":"nome ASC"}')
        .then(response => {
          if (response.data) {
            this.professores = response.data
          }
        })
      },

      async carregaServicesPainel(id) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'ServicePaineis?filter={"where":{"and":[{"empresaId":"' + id + '"},{"login":{"gt":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"login":{"lt":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "include":["aluno", "professor"]}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data.sort(this.compareLogout)
          this.tabela.carregamento = false
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' às ' + hora
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      editarItem(item) {
        this.pegaProfessoresOnline(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
        this.editedItem = Object.assign({}, item)
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.dialogoEditaAluno = true
      },

      async salvarItem() {
        this.isLoading = true

        let dados = {
          "alunoId": this.editedItem.alunoId,
          "professorIdOrigem": this.editedItem.professorId,
          "professorIdDestino": this.professorIdDestino,
          "justificativa": this.justificativaTransferencia,
        }
        
        await axios.post(baseApiUrl + 'ServiceProfessores/transferirAlunos?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.carregaServicesPainel(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            this.dialogoEditaAluno = false
          }
        })

        this.isLoading = false
      },

      async efetuarLogout(item) {
        let r = confirm('Deseja efetuar o logout para o aluno(a) ' + item.aluno.nome + '?')
        if (r) {
          await axios.post(baseApiUrl + 'ServicePaineis/realizaLogoutAluno', { "alunoId": item.alunoId })
          .then(async response => {
            if (response.data) {
              await this.salvaAvaliacao(item.id, 0, '')
              this.carregaServicesPainel(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }
          })
        }
      },

      async pegaProfessoresOnline(id) {
        this.loadingSelect = true
        let professoresLogados = []

        await axios.get(baseApiUrl + 'ServiceProfessores?filter={"where":{"and":[{"empresaId":"' + id +'"},{"login":{"gt":"' + moment().format('YYYY-MM-DD') + 'T00:00:00.000Z"}},{"login":{"lt":"' + moment().format('YYYY-MM-DD') + 'T23:59:00.000Z"}},{"logout":null}]},"include":["professor"]}')
        .then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].professor.id != this.editedItem.professorId) {
                professoresLogados.push({
                  "nome": response.data[i].professor.nome,
                  "id": response.data[i].professor.id,
                })
              }
            }
            this.professores = professoresLogados.sort(this.compare)
            this.loadingSelect = false
          }
        })
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const nomeA = a.nome;
        const nomeB = b.nome;

        let comparison = 0;
        if (nomeA > nomeB) {
          comparison = 1;
        } else if (nomeA < nomeB) {
          comparison = -1;
        }
        return comparison;
      },

      compareLogout(a) {
        let comparison = 0;
        if (a.logout) {
          comparison = 1;
        } else if (!a.logout) {
          comparison = -1;
        }
        return comparison;
      },

      calculaTempoTreino(login, logout) {
        let data1_str = login;
        let data2_str = logout;

        // converter para objetos Date
        let data1 = moment(data1_str);
        let data2 = moment(data2_str);

        // calcular diferença em milissegundos
        let diferenca = moment.duration(data2.diff(data1));

        return (diferenca.hours() < 10 ? '0' + diferenca.hours() : diferenca.hours()) + ':' +
              (diferenca.minutes() < 10 ? '0' + diferenca.minutes() : diferenca.minutes()) + ':' +
              (diferenca.seconds() < 10 ? '0' + diferenca.seconds() : diferenca.seconds())
      },

      async salvaAvaliacao(servicePainelId, nota, canal) {
        await axios.post(baseApiUrl + 'Alunos/avaliacao', {"servicePainelId": servicePainelId, "avaliacao": nota, "canal": canal})
      },

      retornaCorAluno(aula) {
        if (aula.transferido) {
          return 'orange'
        }
        else if (!aula.logout) {
          return 'success'
        }
        else {
          return 'error'
        }
      },

      exportar() {
        const dados = this.tabela.conteudo.map(r => ({
          'Aluno(a)': r.aluno ? r.aluno.nome : 'Aluno não identificado',
          'Entrada': this.formatDateHour(r.login),
          'Saída': r.logout ? this.formatDateHour(r.logout) : '',
          'Tempo de aula': r.logout ? this.calculaTempoTreino(r.login, r.logout) : 'Em treino',
          'Professor(a)': r.professor ? r.professor.nome : '',
          'Avaliação': r.logout && r.notaAula >= 1 ? r.notaAula : r.logout && r.notaAula == 0 ? 'Não avaliou' : 'Aguardando finalizar para avaliar',
          'Canal': r.canal ? r.canal : 'Não avaliou',
          'Justificativa': r.justificativa ? r.justificativa : '-'
        }))

        exportarParaExcel(dados, 'Relatório de Alunos ' + new Date().toLocaleString('pt-BR') + '.xlsx')
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
